import filter from 'lodash/filter';
import store from '@/store';

const typesConfig = {
  article: {
    type: 'article',
    icon: 'text_fields',
    isMedia: false,
    hasWWWPage: true,
  },
  audio: {
    type: 'audio',
    icon: 'audiotrack',
    isMedia: false,
    hasWWWPage: false,
  },
  file: {
    type: 'file',
    icon: 'insert_drive_file',
    isMedia: false,
    hasWWWPage: false,
  },
  image: {
    type: 'image',
    icon: 'photo',
    isMedia: true,
    hasWWWPage: false,
  },
  photogallery: {
    type: 'photogallery',
    icon: 'collections',
    isMedia: true,
    hasWWWPage: true,
  },
  video: {
    type: 'video',
    icon: 'play_arrow',
    isMedia: true,
    hasWWWPage: true,
  },
  videoembed: {
    type: 'videoembed',
    icon: 'videocam',
    isMedia: true,
    hasWWWPage: true,
  },
  live: {
    type: 'live',
    icon: 'forum',
    isMedia: false,
    hasWWWPage: true,
  },
};

/**
 * Available content types.
 * @type {string[]}
 */
const getTypes = () => Object.keys(typesConfig);

/**
 * Content types considered multimedia.
 * @type {string[]}
 */
const getMediaTypes = () => filter(typesConfig, typeConfig => typeConfig.isMedia)
  .map(typeConfig => typeConfig.type);

/**
 * Content mandatory fields
 * @type {string[]}
 */
const mandatoryFields = [
  'title',
  'mainTaxonomyId',
];

/**
 * Content types with landing page.
 * @type {function(): *}
 * @deprecated Use store hasLandingPageContentTypes instead
 */
const getContentsWithLandingPage = () => {
  if (store && store.getters && store.getters.hasLandingPageContentTypes.length > 0) {
    return store.getters.hasLandingPageContentTypes;
  }
  return filter(typesConfig, typeConfig => typeConfig.hasWWWPage).map(typeConfig => typeConfig.type);
};

/**
 * Icon of each content based on its type.
 * @type {{}}
 */
function typeToIcon(type) {
  // Search in the cms config
  if (typesConfig[type]) {
    return typesConfig[type].icon;
  }
  // Search in the store entity form config
  const config = store.getters.getEntityConfig(type);
  if (config && config.icon) {
    return config.icon;
  }
  // No config found for this type
  return 'text_fields';
}

/**
 * Video types that will be allowed to upload on the wizard.
 * @type {{allowedMimes: string}}
 */
const videoWizard = {
  allowedMimes: [
    'video/*', '.flv',
  ].join(','),
};

/**
 * Image types that will be allowed to upload on the wizard.
 * @type {{allowedMimes: string}}
 */
const imageWizard = {
  allowedMimes: 'image/jpg,image/jpeg,image/png',
};

export {
  typesConfig,
  getMediaTypes,
  getTypes,
  mandatoryFields,
  typeToIcon,
  getContentsWithLandingPage,
  videoWizard,
  imageWizard,
};
